// DocumentIcon.jsx
import { DocumentIcon as BaseDocumentIcon} from "@heroicons/react/24/outline";

const DocumentIcon = (props) => {
  return <BaseDocumentIcon {...props} />;
};

export default DocumentIcon;
